module.exports = __webpack_public_path__ + "img/vase_details.e1c9d690.svg";